export default "__VITE_ASSET__CQj_Y84b__"